<template>
  <div class="home">
    <section>
      <h2>Services</h2>
      <div class="row">

        <div class="full">

          <div v-if="!isServiceLoaded">
            <progress-ring radius="60" :progress="servicesProgress" stroke="4"></progress-ring>
          </div>

          <div class="envn" v-if="isServiceLoaded">
            <table v-if="services.length">
              <tr v-for="service in services" @click="goToService(service.id)">
                <td class="srv-name">{{ service.serviceName }}</td>
                <td class="srv-impact">Has {{ service.knownImpacts.length }} impacts</td>
                <td class="srv-uptime">{{ service.errorBudget }} error budget</td>
                <td :class="'srv-fail-' + service.safeToFail"> Is <strong v-if="!service.safeToFail">not</strong> safe to fail</td>
              </tr>
            </table>

            <div class="row" style="margin-top:20px;">
              <div class="fifty">
                <router-link to="/services" class="see-all">See all</router-link>
              </div>
              <div class="fifty">
                <router-link to="/services/create" tag="button">Add a service</router-link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <section>
      <h2>Specs</h2>
      <div v-if="!isSpecLoaded">
        <progress-ring radius="60" :progress="specsProgress" stroke="4"></progress-ring>
      </div>

      <div class="row" v-if="isSpecLoaded">
          <div class="quarter" v-for="spec in specs">
            <div :class="'box ' + spec.status">
              <router-link :to="{ name: 'spec-view', params: { specid: spec.id }}">
              <h3>{{ spec.title }}</h3>
              <p>{{ spec.summary }}</p>
              <p><small>Updated: {{ spec.updated_on | date }}</small></p>
              </router-link>
            </div>
        </div>
      </div>
      <div class="row" style="margin-top:20px;">
        <div class="fifty">
          <router-link to="/specs" class="see-all">See all</router-link>
        </div>
        <div class="fifty">
          <router-link to="/specs/create" tag="button">Add an architecture decision</router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { RepositoryFactory } from '@/services/repositoryfactory'
const ServiceRepository = RepositoryFactory.get('services');
const SpecRepository = RepositoryFactory.get('specs');
import ProgressRing from '@/components/progress-ring.vue'

export default {
  name: 'Home',
  components: {
    ProgressRing
  },
  data () {
    return {
      isServiceLoaded: false,
      isSpecLoaded: false,
      services: null,
      specs: null,
      servicesProgress: 0,
      specsProgress: 0
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.getServices();
      this.getSpecs();
    },

    async getServices() {
      const interval = setInterval(() => {
        this.specsProgress += 1;
        if (this.specsProgress === 100)
          clearInterval(interval);
      }, 100);

      this.services = await ServiceRepository.getAllServices();
      this.isServiceLoaded = true;
    },

    async getSpecs() {
      const interval = setInterval(() => {
        this.servicesProgress += 1;
        if (this.servicesProgress === 100)
          clearInterval(interval);
      }, 100);

      this.specs = await SpecRepository.getAllSpecs();
      this.isSpecLoaded = true;
    },

    goToService(id) {
      this.$router.push({ name: 'service-view', params: { serviceid: id } });
    }

  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    date: function(cdate) {
      if (!cdate) return '';
      var d = new Date(parseInt(cdate));
      return d.toDateString();
    }
  }
}
</script>
